import React, {useEffect, useState} from 'react';
import {DataTableProps} from './DataTable.props';
import './DataTable.styles.css';
import {Badge, Stack, Tooltip} from "@mui/material";
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import {updateLatestFilter} from '../../../api/emailTriage';
import {isMobileOnly} from "react-device-detect";
import {ReactComponent as DynamicColumn} from "../../../assets/images/dynamic_column.svg";

interface GridPinnedColumns {
  left?: string[]; // Optional field names to pin to the left
  right?: string[]; // Optional field names to pin to the right
}

export const DataTable: React.FC<DataTableProps> = ({
  filterData,
  toolbar,
  onChangeRowsPerPage ,
  checkNoFilterColumn,
  CustomPagination,
  rowCount,
  columns,
  actionsColumn,
  data,
  onSelectionModelChange,
  onRowDoubleClick,
  selectionModel,
  onSortModelChange,
  loadingTable= false,
  localeText,
}) => {
  // @ts-ignore
  const userData = JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData'))["userId"] : {};
  const userId = JSON.stringify(userData);
  const dynamicColumn = sessionStorage.getItem("dynamicColumn");
  if (dynamicColumn !== null) {
    filterData = JSON.parse(dynamicColumn);
  }
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(filterData)
  const [visibilityColumn, setVisibilityColumn] = useState(true)
  const [isDot, setDot] = useState(false)
  const checkShowColumn = (presentCol:any) => {
    let visibleCol:any
    if (presentCol !== null) {
      visibleCol = Object.values(presentCol)
    }
    if(visibleCol.length === columns.length){
      let checker = visibleCol.includes(true)
      if(!checker){
        setVisibilityColumn(false)
      } else {
        setVisibilityColumn(true)
      }
    } else {
      setVisibilityColumn(true)
    }
  }

  useEffect(() => {
    let visibleCol:any
    if (dynamicColumn !== null) {
      visibleCol = Object.values(JSON.parse(dynamicColumn))
    }
    if (dynamicColumn !== null) {
      checkShowColumn(JSON.parse(dynamicColumn))
      if(dynamicColumn !== '{}' && visibleCol.length === columns.length){
        setDot(() => dynamicColumn.includes("true"))
      } else {
        setDot(true)
      }
    }
  },[dynamicColumn])

  return(
    <div className='datatable-inbox' style={{ width: '100%' }}>
      <DataGrid
        getRowHeight={isMobileOnly ? () => 'auto' : () => 52}
        headerHeight={visibilityColumn && !isMobileOnly ? 56 : 0}
        localeText={{ toolbarColumns:
            <Tooltip placement={"top"} title="Column selector">
              {isDot ? <DynamicColumn/> : <Badge color="error" variant="dot">
                <DynamicColumn/>
              </Badge> }
            </Tooltip> }}
        onSelectionModelChange={onSelectionModelChange}
        disableColumnMenu
        autoHeight
        disableSelectionOnClick
        rows={visibilityColumn ? data : [] }
        columns={columns}
        components={{
          Pagination: visibilityColumn ? CustomPagination : null,
          Toolbar: toolbar,
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              No data available in table
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <span>All the data was hidden. Click on <strong>column icon</strong></span>
              <span>and select data you want to view.</span>
            </Stack>
          )
        }
       }
        componentsProps={{
          panel: {
            placement: "bottom-end"
          },
        }}
        pagination
        rowCount={rowCount}
        rowsPerPageOptions={[5, 10, 15]}
        onPageSizeChange={onChangeRowsPerPage}
        selectionModel={selectionModel}
        checkboxSelection
        getRowId={(row: any) => row.email_id}
        onCellClick={onRowDoubleClick}
        sortingMode="server"
        onSortModelChange={onSortModelChange}
        loading = {loadingTable}
        columnVisibilityModel={isMobileOnly ? {} : columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel:any) =>
          {
            checkShowColumn(newModel)
            setColumnVisibilityModel(newModel)
            const data = {
              "userId": userId,
              "dynamicColumn":JSON.stringify(newModel),
              "filter": ""
            }
            let visibleCol:any
            if (newModel !== null) {
              visibleCol = Object.values(newModel)
            }
            if(visibleCol.length === columns.length){
              setDot(() => data.dynamicColumn.includes("true"))
            }
            sessionStorage.setItem("dynamicColumn", JSON.stringify(newModel));
            return updateLatestFilter(data).then((result) => {
              if(result.status === 200) {
                // console.log("done")
              }
            });
  
          }
        }
        initialState={{
          sorting: {
            sortModel: [
              {
                field: 'priority',
                sort: 'asc',
              },
            ],
          },
        }}
      />
      {
        visibilityColumn ? actionsColumn : null
      }
      {
        loadingTable && <div style={{
            backgroundColor: "transparent",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }}>
        </div>
      }
      
      
    </div>
  );
};
